import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { QuestionManagementService } from '../../../Services/question-management/question-management.service';
import { AnswerChoiceNoteModel } from 'src/app/Models/AnswerChoiceNote';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddAnswerChoiceNote } from 'src/app/Validators/Validators';
import { ToastrService } from 'ngx-toastr';
import { MATHtest } from '../../../../assets/js/fullscreen';
import { RenderMathjax } from '../../../../assets/js/fullscreen';

@Component({
  selector: 'app-fa-answer-choice-solution-hint',
  templateUrl: './answer-choice-solution-hint.component.html',
  styleUrls: ['./answer-choice-solution-hint.component.css'],
})
export class AnswerChoiceSolutionHintComponent implements OnInit {
  AddAnswerChoiceSolutionform: FormGroup;
  @Input() selectedQuestionById: any;
  @Input() Addsolutionhintpopup: boolean;
  @Input() EditSolutionHintPopup: boolean;
  @Input() AnswerChoiceNotePopup1: boolean;
  @Input() EditSolutionHintBodyPopup: boolean;
  InsertAnswerChoiceNote: AnswerChoiceNoteModel;
  @Output() AddSolutionHintclose: EventEmitter<any> = new EventEmitter<any>();
  @Output() EditAnswerchoiceNoteclose11: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() EditAnswerchoiceNoteclose12: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() EditSolutionHintclose: EventEmitter<any> = new EventEmitter<any>();
  @Output() REdirecttoRightAnswerfromnote: EventEmitter<any> =
    new EventEmitter<any>();
  Buttonflg: string;
  RTEFlag: string = 'AnswerChoiceNote';
  constructor(
    public service: QuestionManagementService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {}

  InitializeForm() {
    this.AddAnswerChoiceSolutionform = this.fb.group({
      Answer_Choice_Note_Text: ['', VAddAnswerChoiceNote],
    });
  }

  ngOnInit() {
    this.InitializeForm();
    if (this.selectedQuestionById.Answer_Choice_ID != null) {
      this.GetAnswerChoiceNoteByID(this.selectedQuestionById.Answer_Choice_ID);
      this.Descriptioncount();
    } else {
      this.GetAnswerChoiceNoteByID(null);
      this.Descriptioncount();
    }
  }

  AnswerChoiceNoteContent: string;
  GetAnswerChoiceNoteContent(data: any) {
    this.AnswerChoiceNoteContent = data;
    //if(this.QuestionBodyContent!=null)
    this.AddAnswerChoiceSolutionform.controls[
      'Answer_Choice_Note_Text'
    ].setValue(this.AnswerChoiceNoteContent);
  }
  AnswerChoiceNoteList: any;
  AnswerChoice: any;
  QuestionBodyget: string;
  GetAnswerChoiceNoteByID(data: any) {
    this.service.GetAnserChoiceNoteByID({ AnswerChoiceID: data }).subscribe(
      (i: any) => {
        this.AnswerChoice = i;
        this.AnswerChoiceNoteList = this.AnswerChoice.AnswerChoiceNoteList;
        if (
          this.AnswerChoiceNoteList != null &&
          this.AnswerChoiceNoteList != undefined
        ) {
          if (this.AnswerChoiceNoteList.length > 0) {
            this.AnswerChoiceNoteList.forEach(
              (
                currentValue: {
                  Answer_Choice_Note_Text: string;
                  Hint_Ind: any;
                },
                index: any
              ) => {
                if (currentValue.Hint_Ind == 'Y') {
                  if (currentValue.Answer_Choice_Note_Text != null) {
                    this.AddAnswerChoiceSolutionform.controls[
                      'Answer_Choice_Note_Text'
                    ].setValue(currentValue.Answer_Choice_Note_Text);
                    this.QuestionBodyget = currentValue.Answer_Choice_Note_Text;

                    this.AnswerChoiceNoteContent =
                      currentValue.Answer_Choice_Note_Text;
                  }
                }
              }
            );
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save_submitted: boolean = false;
  AddAnswerChoiceResponse: any;
  index: Number;
  // Questionid:string;
  modalclose: any;
  SaveAnswerChoiceSolution() {
    this.validate1 = false;
    if (this.AddAnswerChoiceSolutionform.valid) {
      this.InsertAnswerChoiceNote = this.AddAnswerChoiceSolutionform.value;
      this.InsertAnswerChoiceNote.QuestionID =
        this.selectedQuestionById.Question_ID;
      this.InsertAnswerChoiceNote.Question_Status_ID =
        this.selectedQuestionById.Question_Status_ID;
      this.InsertAnswerChoiceNote.Answer_Choice_Id =
        this.selectedQuestionById.Answer_Choice_ID;
      this.InsertAnswerChoiceNote.HintInd = 'Y';
      if (
        this.AnswerChoiceNoteList != null &&
        this.AnswerChoiceNoteList != undefined
      ) {
        if (this.AnswerChoiceNoteList.length > 0) {
          this.AnswerChoiceNoteList.forEach(
            (
              currentValue: {
                Answer_Choice_Note_Id: any;
                Answer_Choice_Note_Text: string;
                Hint_Ind: any;
              },
              index: any
            ) => {
              if (currentValue.Hint_Ind == 'Y') {
                if (currentValue.Answer_Choice_Note_Text != null) {
                  this.InsertAnswerChoiceNote.Answer_Choice_Note_Id =
                    currentValue.Answer_Choice_Note_Id;
                } else {
                  this.InsertAnswerChoiceNote.Answer_Choice_Note_Id = null;
                }
              }
            }
          );
        } else {
          this.InsertAnswerChoiceNote.Answer_Choice_Note_Id = null;
        }
      } else {
        this.InsertAnswerChoiceNote.Answer_Choice_Note_Id = null;
      }
      this.service
        .CreateOrModifyAnswerChoiceNote(this.InsertAnswerChoiceNote)
        .subscribe(
          (i: any) => {
            this.AddAnswerChoiceResponse = i;
            if (this.AddAnswerChoiceResponse.Message == 'Success') {
                    this.toastr.success('Saved Successfully', 'Success',{timeOut: 500});
              this.save_submitted = false;
              // console.log(this.EditQuestionBodyPopup,'EditQuestionBodyPopup');

              if (this.Addsolutionhintpopup) {
                this.AddSolutionHintclose.emit(this.modalclose);
              } else if (this.EditSolutionHintPopup) {
                this.EditSolutionHintclose.emit(this.modalclose);
              } else if (this.EditSolutionHintBodyPopup) {
                this.EditAnswerchoiceNoteclose12.emit(this.modalclose);
              } else {
                this.EditAnswerchoiceNoteclose11.emit(this.modalclose);
              }
            } else {
              this.toastr.error(this.AddAnswerChoiceResponse.Message);
            }
          },
          (error) => {
            this.AddAnswerChoiceResponse = error;
            this.toastr.error(this.AddAnswerChoiceResponse.Message);
            this.save_submitted = false;
            console.log(error);
          }
        );
    }
  }

  Descriptionvaluelength: any;
  DescriptionMaxlength: any;
  Descriptioncount() {
    this.DescriptionMaxlength = 4000;
    if (
      this.AddAnswerChoiceSolutionform.controls.Answer_Choice_Note_Text.value !=
        '' &&
      this.AddAnswerChoiceSolutionform.controls.Answer_Choice_Note_Text.value !=
        null
    ) {
      if (
        this.AddAnswerChoiceSolutionform.controls.Answer_Choice_Note_Text.value
          .length > 0
      ) {
        this.Descriptionvaluelength =
          this.AddAnswerChoiceSolutionform.controls.Answer_Choice_Note_Text.value.length;
      } else {
        this.Descriptionvaluelength = 0;
      }
    } else {
      this.Descriptionvaluelength = 0;
    }
  }

  validate: boolean = false;
  latexeditlist: any[] = [];
  GetLatexBodyContent(data: any) {
    // this.latexeditlist.push({latextext:data.latex,equation:data.mathjax,cursor:data.cursor});
    // console.log(this.latexeditlist,'latexeditlist')
    this.latexeditlist = data;
    console.log(this.latexeditlist, 'latexeditlist');
  }

  Indicator: boolean = false;
  RemoveLatexBodyContent(data: any) {
    console.log(data, 'removecursor');
    for (var j = 0; j < this.latexeditlist.length; j++) {
      console.log(data, j, this.latexeditlist[j].cursor);
      if (this.latexeditlist[j].cursor == data) {
        //this.Indicator=true;
        this.latexeditlist.splice(j, 1);
        break;
        //this.Indicator=true;
        //break;
      }
      // if(this.Indicator)
      // {
      // this.latexeditlist[j].cursor=this.latexeditlist[j].cursor-1;
      // }
    }
  }

  Editlatex(data: any, index: any) {
    console.log(data, 'Editlatex');
    let rendermathjax = RenderMathjax(data);
    console.log(rendermathjax, 'mathjax');
    this.latexeditlist[index].latex = data;
    this.latexeditlist[index].mathjax = rendermathjax;
  }

  copyInput(index: any) {
    this.copyMessage(this.latexeditlist[index].latex);
  }

  copyMessage(val: string) {
    document.body.oncopy = function () {
      return true;
    };
    const selBox = document.createElement('textarea');

    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    //document.body.oncopy = function() { return false; }
  }

  Cancel() {
    this.Buttonflg = 'Cancel';

    // if(this.QuestionBodyget==this.AnswerChoiceNoteContent){
    if (!this.validate1) {
      if (this.service.ScreenTrackName == 'app-fa-question-add-edit') {
        this.Buttonflg = 'Cancel';
      }
      // if(this.service.ScreenTrackName=='app-fa-question-preview'){
      //   this.Buttonflg='Redirecttopreview';
      // }
      if (this.service.ScreenTrackName == 'app-fa-answer-choice-add-edit') {
        this.Buttonflg = 'RedirecttoChoice';
      }
      if (this.Buttonflg == 'Cancel') {
        if (this.Addsolutionhintpopup) {
          this.AddSolutionHintclose.emit(this.modalclose);
        } else if (this.EditSolutionHintPopup) {
          this.EditSolutionHintclose.emit(this.modalclose);
        } else if (this.EditSolutionHintBodyPopup) {
          this.EditAnswerchoiceNoteclose12.emit(this.modalclose);
        } else {
          this.EditAnswerchoiceNoteclose11.emit(this.modalclose);
        }
      } else if (this.Buttonflg == 'RedirecttoChoice') {
        this.REdirecttoRightAnswerfromnote.emit(
          'app-fa-answer-choice-solution-hint'
        );
      }
    } else {
      this.Alertpopup();
    }
  }

  //cancel alert
  validate1: boolean;
  GetLatexBodyContentchanges(data: boolean) {
    this.validate1 = data;
  }

  alertpopupflag: boolean;
  Alertpopup() {
    this.alertpopupflag = !this.alertpopupflag;
  }

  Savecontent() {
    if (this.alertpopupflag) {
      this.Alertpopup();
    }
    this.validate1 = false;
    this.SaveAnswerChoiceSolution();
  }

  close() {
    if (this.alertpopupflag) {
      this.Alertpopup();
    }

    if (this.service.ScreenTrackName == 'app-fa-question-add-edit') {
      this.Buttonflg = 'Cancel';
    }
    // if(this.service.ScreenTrackName=='app-fa-question-preview'){
    //   this.Buttonflg='Redirecttopreview';
    // }
    if (this.service.ScreenTrackName == 'app-fa-answer-choice-add-edit') {
      this.Buttonflg = 'RedirecttoChoice';
    }
    if (this.Buttonflg == 'Cancel') {
      if (this.Addsolutionhintpopup) {
        this.AddSolutionHintclose.emit(this.modalclose);
      } else if (this.EditSolutionHintPopup) {
        this.EditSolutionHintclose.emit(this.modalclose);
      } else if (this.EditSolutionHintBodyPopup) {
        this.EditAnswerchoiceNoteclose12.emit(this.modalclose);
      } else {
        this.EditAnswerchoiceNoteclose11.emit(this.modalclose);
      }
    } else if (this.Buttonflg == 'RedirecttoChoice') {
      this.REdirecttoRightAnswerfromnote.emit(
        'app-fa-answer-choice-solution-hint'
      );
    }
  }
  ///Edit latex

  editlatexbutton: boolean;
  getlatex: string;
  currentindex: number;
  Editlatexbutton(index: any) {
    this.currentindex = index;
    this.Editlatexpopup();
    this.getlatex = this.latexeditlist[index].latex;
  }
  Editlatexpopup() {
    this.editlatexbutton = !this.editlatexbutton;
  }

  closelatexpopup() {
    if (this.latexeditlist[this.currentindex].latex == this.getlatex) {
      if (this.editlatexbutton) {
        this.Editlatexpopup();
      }
    } else {
      this.latexAlertpopup();
    }
  }

  Savelatex() {
    this.latexeditlist[this.currentindex].latex = this.getlatex;
    this.Editlatex(this.getlatex, this.currentindex);
    this.copyMessage(this.getlatex);
    if (this.editlatexbutton) {
      this.Editlatexpopup();
    }
  }
  LatexpopupCancel() {
    if (this.latexeditlist[this.currentindex].latex == this.getlatex) {
      if (this.editlatexbutton) {
        this.Editlatexpopup();
      }
    } else {
      this.latexAlertpopup();
    }
  }

  latexalert: boolean;
  latexAlertpopup() {
    this.latexalert = !this.latexalert;
  }

  Savelatexcontent() {
    this.latexAlertpopup();
    this.Savelatex();
  }
  closelatex() {
    this.latexAlertpopup();
    this.Editlatexpopup();
  }
}
